export const SET_COUPONS = "SET_COUPONS";
export const SET_SPECIFIC_COUPON = "SET_SPECIFIC_COUPON";
